export default "__VITE_ASSET__CZbfTGNV__"